export const USER_AUTHENTICATED_LOGIN = "USER_AUTHENTICATED_LOGIN"
export const USER_TYPE = "USER_TYPE"
export const SIGN_UP_KEY = "SIGN_UP_KEY"
export const OTHER_SKIP = "OTHER_SKIP"
export const USER_TOKEN = "USER_TOKEN"
export const UPDATE_USER_TAGS = "UPDATE_USER_TAGS"
export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const GET_LATEST_NOTIFICATION = "GET_LATEST_NOTIFICATION";
export const UPDATE_NEW_NOTIFICATION = "UPDATE_NEW_NOTIFICATION";
export const GET_PLAN = "GET_PLAN";
export const UPDATE_FIRST_RUN = "UPDATE_FIRST_RUN";
export const TOGGLE_PLAN = "TOGGLE_PLAN";
export const TOGGLE_APPSMORE = "TOGGLE_APPSMORE";
export const TOGGLE_ADD_FEEDS = "TOGGLE_ADD_FEEDS";
export const TOGGLE_MANAGE_FEEDS = "TOGGLE_MANAGE_FEEDS";
export const TOGGLE_THEMES_SECTION = "TOGGLE_THEMES_SECTION";
export const TOGGLE_PUBLISH = "TOGGLE_PUBLISH";
export const TOGGLE_CUSTOMIZATION = "TOGGLE_CUSTOMIZATION";
export const REFRESH_THEMES_SECTION = "REFRESH_THEMES_SECTION";
export const UPDATE_SELECTED_FEED_COUNT = "UPDATE_SELECTED_FEED_COUNT";
export const REMOVE_WALL ="REMOVE_WALL";
export const IS_USER_INFO_UPDATING ="IS_USER_INFO_UPDATING";
export const UPDATE_COLLABRATOR_LIST = "UPDATE_COLLABRATOR_LIST";
export const UPDATE_COLLABRATOR_DATA = "UPDATE_COLLABRATOR_DATA";
export const UPDATE_SELECTED_COLLABRATOR = "UPDATE_SELECTED_COLLABRATOR";

export const APP = "APP"

export const USER_AUTHENTICATED = "USER_AUTHENTICATED"

export const MOD_DATA = "MOD_DATA"
export const MOD_CHECK = "MOD_CHECK"
export const MOD_PIN = "MOD_PIN"
export const MOD_PST_ST = "MOD_PST_ST"
export const MOD_DETAILS = "MOD_DETAILS"
export const MOD_FLT_BD_DATE = "MOD_FLT_BD_DATE"
export const MOD_FLT_LIMIT = "MOD_FLT_LIMIT"
export const MOD_TAB = "MOD_TAB"
export const MOD_LOD = "MOD_LOD"
export const MOD_SRC_TAG = "MOD_SRC_TAG"
export const MOD_TAB_CNT = "MOD_TAB_CNT"
export const MOD_PAGIN = "MOD_PAGIN"
export const MOD_SEC_PST = "MOD_SEC_PST"
export const MOD_EP_LOD = "MOD_EP_LOD"
export const MOD_FLT_TAG = "MOD_FLT_TAG"
export const MOD_FLT_FEED = "MOD_FLT_FEED"
export const MOD_FLT_TYPE = "MOD_FLT_TYPE"
export const MOD_FLT_RULE = 'MOD_FLT_RULE'
export const MOD_FLT_RULE_RM = 'MOD_FLT_RULE_RM'
export const MOD_FLT_DATE = "MOD_FLT_DATE"
export const MOD_FLT_DATE_RM = "MOD_FLT_DATE_RM"
export const MOD_FLT_TAG_RM = "MOD_FLT_TAG_RM"
export const MOD_FLT_FEED_RM = "MOD_FLT_FEED_RM"
export const MOD_FLT_TYPE_RM = "MOD_FLT_TYPE_RM"
export const MOD_RECOMM = 'MOD_RECOMM'
export const MOD_RECOMM_RM = 'MOD_RECOMM_RM'
export const MOD_SENTI = 'MOD_SENTI'
export const MOD_SENTI_RM = 'MOD_SENTI_RM'
export const MOD_LANG = 'MOD_LANG'
export const MOD_LANG_RM = 'MOD_LANG_RM'
export const MOD_ALL_FLT_RM = "MOD_ALL_FLT_RM"
export const MOD_FLT_TAG_EXTD = "MOD_FLT_TAG_EXTD"
export const MOD_PIN_LIST = "MOD_PIN_LIST";
export const MOD_CHECK_DT = "MOD_CHECK_DT"
export const MOD_CHECK_DT_RM = "MOD_CHECK_DT_RM"
export const MOD_CHECK_DT_ALL = "MOD_CHECK_DT_ALL"
export const MOD_CHECK_DT_B = "MOD_CHECK_DT_B"
export const MOD_CHECK_DT_BRM = "MOD_CHECK_DT_BRM"
export const MOD_OFFSET = "MOD_OFFSET"
export const MOD_UGC_RM = "MOD_UGC_RM"
export const MOD_UGC = "MOD_UGC"
export const MOD_NOTI = 'MOD_NOTI';
export const UGC_DATA = 'UGC_DATA';
export const UGC_DATA_RM = 'UGC_DATA_RM';
export const UGC_TMP_UP = 'UGC_TMP_UP';
export const UGC_TMP_ADD = 'UGC_TMP_ADD';
export const UGC_TMP_RM = 'UGC_TMP_RM';
export const UGC_REQ_DATA = 'UGC_REQ_DATA';
export const MOD_SV_TAG = 'MOD_SV_TAG';
export const MOD_RM_TAG = 'MOD_RM_TAG';
export const MOD_PST_REF = 'MOD_PST_REF';
export const MOD_PST_FILE_UPDATE = 'MOD_PST_FILE_UPDATE';


//LOADER 
export const MOD_FLT_LOD = "MOD_FLT_LOD"
export const MOD_REFR = "MOD_REFR"
export const WALL_LOAD_REQ = "WALL_LOAD_REQ"
export const CREATE_N_WALL = "CREATE_N_WALL"


//TRANSACTIONS KEYS
export const PROD_SUBSCRIPTION = "PROD_SUBSCRIPTION"
export const SOCIAL_ACCOUNT_DATA = "SOCIAL_ACCOUNT_DATA"
export const ADD_ACCOUNT_DATA = "ADD_ACCOUNT_DATA"
export const DELETE_SOCIAL_ACCOUNT_DATA = "DELETE_SOCIAL_ACCOUNT_DATA"
export const SAVED_CARDS_DATA = "SAVED_CARDS_DATA"

export const ACCOUNT_INFO_DATA = "ACCOUNT_INFO_DATA"
export const WIDGET_ADDON_DATA = "WIDGET_ADDON_DATA"
export const UGC_ADDON_DATA = "UGC_ADDON_DATA"
export const ACCOUNT_CARD_DATA = "ACCOUNT_CARD_DATA"

//DASHBOARD KEYS
export const DASHBOARD_WALL_LOADER = "DASHBOARD_WALL_LOADER"
export const DASHBOARD_DATA = "DASHBOARD_DATA";
export const ROI_VALUE_UPDATE = "ROI_VALUE_UPDATE";
export const RECENT_POST_LOADER = "RECENT_POST_LOADER"
export const GET_RECENT_POST_DATA = "GET_RECENT_POST_DATA"
export const RECENT_POST_DATA = "RECENT_POST_DATA"


export const VISITOR_CLICKS_LOADER = "VISITOR_CLICKS_LOADER"
export const VISITOR_CLICKS_DATA = "VISITOR_CLICKS_DATA"

export const MOST_ACTIVE_USERS_DASHBOARD_LOADER = "MOST_ACTIVE_USERS_DASHBOARD_LOADER"
export const MOST_ACTIVE_USERS_DASHBOARD = "MOST_ACTIVE_USERS_DASHBOARD"

export const WALL_SENTIMENT_LIVE_DASHBOARD_LOADER = "WALL_SENTIMENT_LIVE_DASHBOARD_LOADER"
export const GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA = "GET_WALL_SENTIMENT_LIVE_TREND_DASHBOARD_DATA"


//WALLS
export const ADD_NEW_WIDGET_WALLS = "ADD_NEW_WIDGET_WALLS";
export const DELETE_WIDGET_WALLS = "DELETE_WIDGET_WALLS";
export const WIDGET_WALL_DATA_UPDATE = "WIDGET_WALL_DATA_UPDATE";
export const WIDGET_WALLS = "WIDGET_WALLS";
export const WIDGET_WALL_DATA = "WIDGET_WALL_DATA";
export const GET_WIDGET_WALL_DATA = 'GET_WIDGET_WALL_DATA';
export const GET_CURRENCY_USD_TO_INR = 'GET_CURRENCY_USD_TO_INR';




//App & More
export const APPS_MORE_BANNER_DETAIL = "APPS_MORE_BANNER_DETAIL";
export const APPS_MORE_FILTERS = "APPS_MORE_FILTERS";
export const APPS_MORE_HASTAG_HIGHLIGHTER = "APPS_MORE_HASTAG_HIGHLIGHTER";
export const APPS_MORE_CUSTOM_LANGUAGE = "APPS_MORE_CUSTOM_LANGUAGE";
export const GET_FONTS = "GET_FONTS";
export const AUTO_MOD_LIST = "AUTO_MOD_LIST";

export const GET_GOOGLE_TRACKING_ID = "GET_GOOGLE_TRACKING_ID";
export const GET_CTA_STATUS = "GET_CTA_STATUS";
export const GET_CUSTOM_CSS_STATUS = "GET_CUSTOM_CSS_STATUS";

export const GET_COLLABORATORS = "GET_COLLABORATORS"
export const THEME_UPDATE = "THEME_UPDATE"

export const ACTIVE_VIDEO_POPUP = "ACTIVE_VIDEO_POPUP";

export const WIDGET_TAGS = "WIDGET_TAGS"
export const WIDGET_DATA = "WIDGET_DATA"
export const SNAPUP_DETAILS = "SNAPUP_DETAILS"
export const PHOTOBOOTH_UPDATE = "PHOTOBOOTH_UPDATE"

//analytics
export const STUDIO_LOADER = "STUDIO_LOADER";


export const UPDATE_STATUS_KEY = "UPDATE_STATUS_KEY";

export const GET_WALL_REACTIONS_POST_LOADER = "GET_WALL_REACTIONS_POST_LOADER";
export const GET_WALL_REACTIONS_POST = "GET_WALL_REACTIONS_POST";


//ANALYTICS
export const START_FEEDS_LOADER = "START_FEEDS_LOADER";
export const GET_USER_FEEDS = "GET_USER_FEEDS";
export const GET_USER_FEEDS_REFRESH = "GET_USER_FEEDS_REFRESH";
export const GET_WALL_RECORD_COUNTS = "GET_WALL_RECORD_COUNTS";
export const UPDATE_FEEDS = 'UPDATE_FEEDS';
export const GET_WALL_RECORD_MOST_ACTIVE_USERS = "GET_WALL_RECORD_MOST_ACTIVE_USERS";
export const GET_WALL_RECORD_INFLUENTIAL_CONTRIBUTORS = "GET_WALL_RECORD_INFLUENTIAL_CONTRIBUTORS"; 
export const GET_WALL_RECORD_OVERVIEW = "GET_WALL_RECORD_OVERVIEW";
export const GET_WALL_RECORD_TYPE_BY_POST_NETWORK = "GET_WALL_RECORD_TYPE_BY_POST_NETWORK";
export const GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS = "GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS";

export const GET_WALL_RECORD_WORD_CLOUD = "GET_WALL_RECORD_WORD_CLOUD";
export const GET_WALL_RECORD_POST_OVERVIEW = "GET_WALL_RECORD_POST_OVERVIEW";
export const GET_WALL_RECORD_POST_BY_MENTION_AND_HIGHEST_SHARED = "GET_WALL_RECORD_POST_BY_MENTION_AND_HIGHEST_SHARED";

export const GET_WALL_RECORD_POST_BY_MENTION = "GET_WALL_RECORD_POST_BY_MENTION";
export const GET_WALL_RECORD_POST_BY_HIGHEST_SHARED = "GET_WALL_RECORD_POST_BY_HIGHEST_SHARED";



export const GET_WALL_POST_CLICK_BY_PLATFORMS = "GET_WALL_POST_CLICK_BY_PLATFORMS";

export const GET_POST_CLICK_PLATFORMS = "GET_POST_CLICK_PLATFORMS";
export const GET_TOP_POST_PERFORMANCE = "GET_TOP_POST_PERFORMANCE";

export const UPDATE_WALL_AND_FEED = "UPDATE_WALL_AND_FEED";
export const UPDATE_DATE_FILTER = "UPDATE_DATE_FILTER";
export const UPDATE_SELECTED_FEED = "UPDATE_SELECTED_FEED"; 

export const ANALYTICS_STATUS = "ANALYTICS_STATUS";
export const ANALYTICS_TRIAL_API_ACCESS = "ANALYTICS_TRIAL_API_ACCESS";

export const UPDATE_ANALYTICS_STATUS = "UPDATE_ANALYTICS_STATUS";


 
export const PAGE_REFRESH = "PAGE_REFRESH";
export const PAGE_NOT_FOUND = "PAGE_NOT_FOUND";
 

export const FETCH_ACCOUNTS = "FETCH_ACCOUNTS"

export const MANAGEFEEDS_GET_DATA = "MANAGEFEEDS_GET_DATA"
export const DISPATCH_DELETE_FEED = "DISPATCH_DELETE_FEED"
export const DISPATCH_FEED_STATUS = "DISPATCH_FEED_STATUS"
export const DISPATCH_UPDATE_ACCOUNT = "DISPATCH_UPDATE_ACCOUNT"


export const DISCONNECT_ACC = "DISCONNECT_ACC"
export const SET_ACCOUNT_FEED = "SET_ACCOUNT_FEED"
export const FETCH_PERSONAL_ACCOUNT = "FETCH_PERSONAL_ACCOUNT"
export const ADD_FEED_NETWORKS = "ADD_FEED_NETWORKS"
export const OPEN_UGC = "OPEN_UGC"

export const UPDATE_WALL_FEED = "UPDATE_WALL_FEED";

//Display

//DASHBOARD KEYS
export const FEED_COUNT = "FEED_COUNT";
export const RECENT_WALL_COUNT = 'RECENT_WALL_COUNT';
export const POST_THIS_WEEK = 'POST_THIS_WEEK';
export const SOCIAL = 'SOCIAL';
export const SOCIAL_LOADER = 'SOCIAL_LOADER';



//display
export const TOGGLE_PLAN_D = "TOGGLE_PLAN_D";
export const TOGGLE_APPSMORE_D = "TOGGLE_APPSMORE_D";
export const TOGGLE_ADD_FEEDS_D = "TOGGLE_ADD_FEEDS_D";
export const TOGGLE_MANAGE_FEEDS_D = "TOGGLE_MANAGE_FEEDS_D";
export const TOGGLE_THEMES_SECTION_D = "TOGGLE_THEMES_SECTION_D";
export const TOGGLE_PUBLISH_D = "TOGGLE_PUBLISH_D";
export const TOGGLE_CUSTOMIZATION_D = "TOGGLE_CUSTOMIZATION_D";
export const TOGGLE_AUTOPILOT_D = "TOGGLE_AUTOPILOT_D";
export const REFRESH_THEMES_SECTION_D = "REFRESH_THEMES_SECTION_D";
export const UPDATE_EMAIL_CAMPAIGNS = "UPDATE_EMAIL_CAMPAIGNS";

// STUSIO CODE START
export const STUDIO_UPDATE_NOTICEBOARD = "STUDIO_UPDATE_NOTICEBOARD";
export const STUDIO_UPDATE_WEATHER_APP = "STUDIO_UPDATE_WEATHER_APP";
export const STUDIO_UPDATE_CLOCK = "STUDIO_UPDATE_CLOCK";
export const STUDIO_UPDATE_MOTIVATIONAL_QUOTES = "STUDIO_UPDATE_MOTIVATIONAL_QUOTES";
export const QUOTE_CATEGORY = "QUOTE_CATEGORY";
export const GET_QUOTE_VALUE = "GET_QUOTE_VALUE";
export const STUDIO_UPDATE_CALENDAR = "STUDIO_UPDATE_CALENDAR"
export const STUDIO_SAVE_UPDATE_APP = "STUDIO_SAVE_UPDATE_APP"
export const STUDIO_SCENE_CONTENT_UPDATE_ORDER = "STUDIO_SCENE_CONTENT_UPDATE_ORDER"
export const LOGIN_INTERCOME_DATA = "LOGIN_INTERCOME_DATA";
export const UPDATE_STUDIO_SCENE_STATUS = "UPDATE_STUDIO_SCENE_STATUS";
export const PROTECTED_WALL_STATUS = "PROTECTED_WALL_STATUS";
export const PROTECTED_WALL_WALLKEY = "PROTECTED_WALL_WALLKEY";
export const STUDIO_UPDATE_LEADERBOARD_APP = "STUDIO_UPDATE_LEADERBOARD_APP";

// ProductSubscription 
export const PRODUCT_SUBSCRIPTION_CANCELANCELLATION = "PRODUCT_SUBSCRIPTION_CANCELANCELLATION";
export const PRODUCT_CANCELANCELLATION_STATUS = "PRODUCT_CANCELANCELLATION_STATUS";


export const GET_ALL_CONTENT_DATA = "GET_ALL_CONTENT_DATA"
export const UPDATE_SELECTED_FEED_DATA = "UPDATE_SELECTED_FEED_DATA"
export const GET_TRUE_SENSE_RECOMMENDATION = "GET_TRUE_SENSE_RECOMMENDATION"
export const GET_POST_LANGUAGE = "GET_POST_LANGUAGE"
export const GET_TOP_AI_TAGS = "GET_TOP_AI_TAGS"
export const GET_ASSETS_NETWORK = "GET_ASSETS_NETWORK"
export const GET_EVENT_VOICE = "GET_EVENT_VOICE"
export const GET_LEADER_BOARD = "GET_LEADER_BOARD"
export const GET_SENTIMENTS_DATA = "GET_SENTIMENTS_DATA"
export const GET_SENTIMENT_STATISTICS = "GET_SENTIMENT_STATISTICS"
export const GET_SENTIMENT_LIVE_TREND = "GET_SENTIMENT_LIVE_TREND"
export const GET_CONTENT_ANALYTICS = "GET_CONTENT_ANALYTICS"
export const GET_WORD_CLOUD = "GET_WORD_CLOUD"
export const GET_POST_TYPE_COUNT = "GET_POST_TYPE_COUNT"
export const GET_WIDGET_ANALYTICS = "GET_WIDGET_ANALYTICS"
export const GET_HIGHEST_POST_SHARED = "GET_HIGHEST_POST_SHARED"
export const GET_FLAGES = "GET_FLAGES"
export const GET_SCREEN_ANALYTICS_DATA = "GET_SCREEN_ANALYTICS_DATA"
export const GET_SCREEN_OVERVIEW_DATA = "GET_SCREEN_OVERVIEW_DATA"
export const GET_PERFORMING_POST_DATA = "GET_PERFORMING_POST_DATA"
export const GET_TOP_REACTED_POSTS_DATA = "GET_TOP_REACTED_POSTS_DATA"
export const GET_POST_OVERVIEW_ = "GET_POST_OVERVIEW"
export const GET_ALL_WEB_DATA = "GET_ALL_WEB_DATA"
export const GET_WEB_POST_OVERVIEW_DATA = "GET_WEB_POST_OVERVIEW_DATA"
export const GET_WEB_ANALYTIC_DATA = "GET_WEB_ANALYTIC_DATA"
export const GET_WALL_SENTIMENT_LIVE_TREND_DATA = "GET_WALL_SENTIMENT_LIVE_TREND_DATA"
export const ACTIVE_TAB = "ACTIVE_TAB"

export const CONTENT_LOADER   = "CONTENT_LOADER"
export const SENTIMENT_LOADER = "SENTIMENT_LOADER"
export const GET_WALL_SENTIMENT_LIVE_TREND_LOADER = "GET_WALL_SENTIMENT_LIVE_TREND_LOADER"


export const ANALYTICS_STATUS_LOADER = "ANALYTICS_STATUS_LOADER"
export const LEADER_BOARD_LOADER = "LEADER_BOARD_LOADER"
export const TOP_EVENT_LOADER = "TOP_EVENT_LOADER"
export const TRUSENSE_LOADER = "TRUSENSE_LOADER"
export const WORD_LOADER = "WORD_LOADER"
export const TOP_AI_LOADER = "TOP_AI_LOADER"
export const POST_TYPE_COUNT_LOADER = "POST_TYPE_COUNT_LOADER"
export const POST_BY_LANGUAGE_LOADER = "POST_BY_LANGUAGE_LOADER"
export const POSTS_BY_NETWORK_LOADER = "POSTS_BY_NETWORK_LOADER"
export const GET_SCREEN_ANALYTICS_LOADER = "GET_SCREEN_ANALYTICS_LOADER"
export const GET_SCREEN_OVERVIEW_DATA_LOADER = "GET_SCREEN_OVERVIEW_DATA_LOADER"
export const GET_PERFORMING_POST_LOADER = "GET_PERFORMING_POST_LOADER"
export const GET_TOP_REACTED_POSTS_DATA_LOADER = "GET_TOP_REACTED_POSTS_DATA_LOADER"
export const GET_POST_OVERVIEW_LOADER = "GET_POST_OVERVIEW_LOADER"
export const GET_ALL_WEB_DATA_LOADER = "GET_ALL_WEB_DATA_LOADER"
export const GET_WEB_POST_OVERVIEW_LOADER = "GET_WEB_POST_OVERVIEW_LOADER"
export const GET_WEB_ANALYTIC_LOADER = "GET_WEB_ANALYTIC_LOADER"
export const UPDATE_FILTER_DATE = "UPDATE_FILTER_DATE"


// STUDIO
export const GET_USER_STUDIO_WALL = "GET_USER_STUDIO_WALL";
export const GET_SCENES = "GET_SCENES";
export const UPDATE_SCENES = "UPDATE_SCENES";
export const ACTIVE_SCENE = "ACTIVE_SCENE";
export const UPDATE_LAYOUT = "UPDATE_LAYOUT";
export const LAYOUTS = "LAYOUTS";
export const STUDIO_APPS = "STUDIO_APPS";

export const UPDATE_SECENE_STATUS_KEY = "UPDATE_SECENE_STATUS_KEY";
export const DELETE_SCENE_CONTENT_KEY = "DELETE_SCENE_CONTENT_KEY";
export const STUDIO_DELETE_SCENE_KEY = "STUDIO_DELETE_SCENE_KEY";
export const STUDIO_SAVE_DISPLAY_WALL_KEY = "STUDIO_SAVE_DISPLAY_WALL_KEY";
export const STUDIO_SAVE_LINK_WALL_KEY = "STUDIO_SAVE_LINK_WALL_KEY";
export const STUDIO_SAVE_SHORT_CODE_KEY = "STUDIO_SAVE_SHORT_CODE_KEY";
export const STUDIO_SAVE_IMAGE_KEY = "STUDIO_SAVE_IMAGE_KEY";
export const STUDIO_CREATE_NEW_SCENE = "STUDIO_CREATE_NEW_SCENE";
export const STUDIO_SCENE_RE_ORDER_KEY = "STUDIO_SCENE_RE_ORDER_KEY";
export const STUDIO_SCENE_CONTENT_RE_ORDER_KEY = "STUDIO_SCENE_CONTENT_RE_ORDER_KEY";
export const STUDIO_SCENE_DUPLICATE = "STUDIO_SCENE_DUPLICATE";
export const STUDIO_SCENE_CONTENT_UPDATE_DURATION = "STUDIO_SCENE_CONTENT_UPDATE_DURATION";
export const STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE = "STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE";
export const STUDIO_GET_URL_DATA_FOR_UPDATE = "STUDIO_GET_URL_DATA_FOR_UPDATE";
export const STUDIO_GET_MEDIA_DATA_FOR_UPDATE = "STUDIO_GET_MEDIA_DATA_FOR_UPDATE";
export const STUDIO_UPDATE_IMAGE_KEY = "STUDIO_UPDATE_IMAGE_KEY";
export const STUDIO_SAVE_APP = "STUDIO_SAVE_APP";



export const STUDIO_UPDATE_EMBED_SHORT_CODE_KEY = "STUDIO_UPDATE_EMBED_SHORT_CODE_KEY";

export const STUDIO_UPDATE_URL_KEY = "STUDIO_UPDATE_URL_KEY";
export const STUDIO_UPDATE_QRCODE = "STUDIO_UPDATE_QRCODE";
export const STUDIO_UPDATE_COUNTER = "STUDIO_UPDATE_COUNTER";
export const WALL_ID = "WALL_ID";
export const UPDATE_EXPANDED_ACCORDION = "UPDATE_EXPANDED_ACCORDION";

export const UPDATE_SCENE_NAME = "UPDATE_SCENE_NAME";
export const UPDATE_SCENE_HEIGHT = "UPDATE_SCENE_HEIGHT";
export const UPDATE_POST_TYPE = "UPDATE_POST_TYPE";
export const UPDATE_DEMO_POST = "UPDATE_DEMO_POST";
export const TOGGLE_PHOTOBOOTH_UPGRADE = "TOGGLE_PHOTOBOOTH_UPGRADE"